export default __webpack_public_path__ + "static/media/ico-10.f6d73bd5.png";